<template>
	<div class="w-full">
		<div
			class="flex min-h-[230px] items-center rounded from-[#0076BB] via-[#0382cc] to-[#22D9F2] p-8 bg-gradient-[137deg] lg:p-6"
		>
			<div class="w-full text-center">
				<p class="text-white">Limited time only</p>
				<p
					class="py-2 font-heading text-[3rem] font-bold leading-none text-white"
				>
					$0
					<br class="md:hidden" />
					<span class="text-4xl md:text-[3rem]">upfront fee*</span>
				</p>
				<TermsAndConditions
					:is-full-width="false"
					custom-class="mt-4"
					font-color="text-white"
				>
					*Applicable to selected vehicles only
				</TermsAndConditions>
			</div>
		</div>
	</div>
</template>

<script setup>
import TermsAndConditions from '@/components/fineprint/TermsAndConditions.vue'
</script>
